export default __webpack_public_path__ + "static/media/img-0629-moldova-full-face.97e393ac.png";